import {
    DjangoLicenseType,
    ICartLicense,
    IDjangoApi1License,
    hasOwnProperty,
    isDjangoLicenseType,
} from '../../tn.common';
import { hasAnyLicenseOfTypeActive } from './has-any-license-of-type-active';
import { cartLicenseIsRenewal } from './license-has-renewal';
import { cartLicenseIsUpgrade } from './license-has-upgrade';

/**
 * given a set of existing licenses and propose (Cart) licenses, return a list of existing licenses for the proposed licenses.
 */
export function licensesToUpgradeFrom(
    existing: IDjangoApi1License[],
    proposed: ICartLicense[]
): IDjangoApi1License[] {
    const matchCriteria: Record<number, DjangoLicenseType[]> = {};
    const matchKeys: number[] = [];

    // collect a list of the proposed fonts and their respective license types.
    proposed.forEach((license) => {
        Object.keys(license.fontRights).forEach((licenseType) => {
            if (!isDjangoLicenseType(licenseType)) return;
            if (
                !cartLicenseIsUpgrade(license, licenseType) &&
                !cartLicenseIsRenewal(license, licenseType)
            )
                return;

            if (!hasOwnProperty(matchCriteria, license.font.id)) {
                matchCriteria[license.font.id] = [];
                matchKeys.push(license.font.id);
            }
            matchCriteria[license.font.id].push(licenseType);
        });
    });

    // filter existing licenses to only those that match the proposed licenses.
    return existing.filter((license) => {
        return (
            matchKeys.indexOf(license.style.id) !== -1 &&
            matchCriteria[license.style.id].some((key) =>
                hasAnyLicenseOfTypeActive([license], key)
            )
        );
    });
}
